/**
 * Standard error response format from Vapor backend
 */
export interface VaporErrorResponse {
  data?: any;
  error: boolean;
  reason: string;
}

/**
 * Type guard to check if an error is a Vapor error response
 */
export function isVaporError(error: any): error is { response: { data: VaporErrorResponse } } {
  return (
    error &&
    error.response &&
    error.response.data &&
    typeof error.response.data === 'object' &&
    error.response.data.error === true &&
    typeof error.response.data.reason === 'string'
  );
}

/**
 * Extract error message from Axios error response
 * Handles both Vapor-specific error format and generic errors
 */
export function extractErrorMessage(error: any): string {
  // Check if it's a Vapor-formatted error
  if (isVaporError(error)) {
    return error.response.data.reason;
  }

  // Handle other types of errors
  if (error.response?.data?.message) {
    return error.response.data.message;
  }

  if (error.message) {
    return error.message;
  }

  // Fallback for unknown error formats
  return 'An unexpected error occurred. Please try again.';
}
